import { EllipsedText, FlexRow, MaterialIcon, useModal } from '@gorila-shared-ui/components';
import Button from 'baseui/button/button';
import { LabelSmall, ParagraphSmall } from 'baseui/typography';
import { memo } from 'react';
import { useCamera } from '../../hooks/useCamera';
import { useStyles } from '../../hooks/useStyles';
import { JobCore } from '../../types/jobs';
import { isValidPosition } from '../../utils/map';
import StyledTooltip from '../ui/StyledTooltip';
import { JobModal } from './JobModal';

type Props = {
  job: JobCore;
};
function JobCardHeader({ job }: Readonly<Props>) {
  const { theme, css } = useStyles();
  const { showModal, openModal, closeModal } = useModal();
  const { zoomTo } = useCamera();

  const isValidPoint = isValidPosition(job.latitude, job.longitude);

  const lng = job.longitude;
  const lat = job.latitude;

  return (
    <FlexRow
      classNames={css({
        padding: `${theme.sizing.scale200} ${theme.sizing.scale400}`,
        alignItems: 'center',
        justifyContent: 'space-between',
      })}
    >
      <StyledTooltip content="Nombre del trabajo">
        <LabelSmall margin={'2px 0 0'}>
          <EllipsedText
            breakAll
            inline
          >
            {job.name}
          </EllipsedText>
        </LabelSmall>
      </StyledTooltip>
      <FlexRow
        gap={0}
        classNames={css({ alignItems: 'center' })}
      >
        <StyledTooltip content="Estatus">
          <ParagraphSmall
            margin={0}
            color={job.status.color ? job.status.color : undefined}
          >
            {job.status.name}
          </ParagraphSmall>
        </StyledTooltip>
        <StyledTooltip
          content={'Ver detalle'}
          showArrow={false}
        >
          <Button
            size="mini"
            shape="square"
            onClick={openModal}
            kind="tertiary"
          >
            <MaterialIcon
              name={'visibility'}
              size="xs-mini"
            />
          </Button>
        </StyledTooltip>
        {isValidPoint && (
          <StyledTooltip
            content={'Encontrar en el mapa'}
            showArrow={false}
          >
            <Button
              size="mini"
              shape="square"
              onClick={() => zoomTo({ lat, lng })}
              kind="tertiary"
            >
              <MaterialIcon
                name={'location_searching'}
                size="xs-mini"
              />
            </Button>
          </StyledTooltip>
        )}
      </FlexRow>
      {showModal && (
        <JobModal
          jobId={job._id}
          isOpen={showModal}
          onClose={closeModal}
        />
      )}
    </FlexRow>
  );
}

export default memo(JobCardHeader);
